import axios from "axios";
import Constants from "../../../components.constants.js";


export default {
  async getJobsReportFromServer(context, payload = {}) {
    try {
      let logsUrl = Constants.sessionUserJobsReportUrl;
      if(payload.isPrivExists){
        logsUrl = Constants.JobsReportUrl;
      }
      delete payload["isPrivExists"]
      let resp = await axios.get(logsUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getJobsReportFromServer][Store][Error occured while gettingJobds report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getDeletedPermanentlyReport(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.deletedPermanentlyReportURL, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getStorageReportFromServer][Store][Error occured while gettingstorage report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getMarkedForDeleteReport(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.markedForDeleteReportURL, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getMarkedForDeleteReport][Store][Error occured while gettingstorage report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  
  async downloadjobsReportFromServer(context, payload = {}) {
    try {
      let url = Constants.downloadJobsSessionReportUrl;
      if(payload.isPrivExists){
        url = Constants.downloadJobsReportUrl;
      }
      let modifiedPayload = { ...payload };
      delete modifiedPayload.isPrivExists;
      let resp = await axios.get(url,modifiedPayload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        return resp;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[downloadjobsReportFromServer][Store][Error occured while getting download jobs report list--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async getUsersAutoComplitionFromServerIngest(context, payload ={}){
    try {
      let resp = await axios.get(Constants.usersAutoComplitionUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getUsersAutoComplitionFromServer][Store][Error occured while getting userslist--->${error}]`
      );
      if (error.response) {
        error.response.data.statusCode = error.response.status
        return error.response.data
      }
      return {}
    }
  },

  async getAllUsersFromServerIngest(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.usersUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAllUsersFromServer][Store][Error occured while getting userslist--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("logOutFromServer")
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

};
